import { default as defaultData } from "./default.json";
import { default as updateEmail } from "./update-email.json";

const data: { [key: string]: object } = {
  default: defaultData,
  updateEmail: updateEmail,
};

const profile = {
  get: () => data["default"],
  update: (values: any) => {
    const currentUser = data["default"] as any;
    currentUser.data.attributes.first_name = values.user.first_name;
    currentUser.data.attributes.last_name = values.user.last_name;
    return currentUser;
  },
  updateEmail: () => data["updateEmail"],
};

export default profile;
